//deps
import { HTTP_METHODS, makeDownstreamApiCallDeprecated } from "@swiggy-private/checkout-core";
import { ApiResponse, unwrapResponseWithCode } from "@swiggy-private/core-utils";
import { Err, Ok, Result } from "@swiggy-private/js-fp";

//constants
import { DOWNSTREAM_ENDPOINTS, DOWNSTREAM_HOSTS } from "@dineout-cart-client/constants/Hosts";
import { SERVICE_LINE } from "@dineout-cart-client/constants";

async function createPaymentLink(): Promise<string> {
    const response = unwrapResponseWithCode<string>(
        (await makeDownstreamApiCallDeprecated({
            apiHost: DOWNSTREAM_HOSTS.DO_HOST,
            endpoint: DOWNSTREAM_ENDPOINTS.CREATE_PAYMENT_LINK_URI,
            options: {
                method: HTTP_METHODS.POST,
                // This is required only for temperory purpose of unblocking events release since iOS has not included this header
                // TODO: cleanup the change post iOS release is done for passing this header
                headers: {
                    "service-line": SERVICE_LINE,
                },
            },
        })) as ApiResponse<string>,
    );
    return response.toPromise();
}

export function createPaymentLinkWrapper(): Promise<Result<string, Error | ApiResponse>> {
    return createPaymentLink()
        .then(paymentLinkResponse => {
            return Ok(paymentLinkResponse);
        })
        .catch(err => {
            return Err(err);
        });
}
